getTitleForCustomRows